<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 cust-overflow-y-primary-color"
  >
    <div
      class="flex  sidebar-topfixpart bg-primary justify-between p-4 add-sidebar-top mt-20"
    >
      <h2 class="h2-class font-semibold uppercase text-white ">
        ADD Shipment
      </h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="px-4 pt-20 mt-20 pb-12">
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">AWB Number</p>
        <b-input placeholder="Enter Number..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Customer Name</p>
        <b-input placeholder="Enter Name..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Email ID</p>
        <b-input placeholder="Enter  EmailID..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Choose Couriers</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>FedEx</option>
            <option>BlueDart</option>
            <option>FirstFlight</option>
            <option>DTDC</option>
            <option>DHL</option>
          </select>
        </base-input>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Shipment Type</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Forward</option>
            <option>Faster</option>
          </select>
        </base-input>
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Order ID</p>
        <b-input placeholder="Enter  orderID..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Mobile Number</p>
        <b-input placeholder="Enter  Mobile..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Company Name</p>
        <b-input placeholder="Enter Company Name..." />
      </div>
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Choose Country</p>

        <base-input class="div-mb-0">
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>India</option>
            <option>America</option>
            <option>Srilanka</option>
            <option>NewZealand</option>
          </select>
        </base-input>
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0	w-1/4 ">
      <base-button block type="primary" class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {};
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  }
};
</script>
